import React, { useState, useEffect, useCallback } from 'react';
import qs from 'qs';

import server from 'server/serverController2';
import { formatPhoneNumber, formatPriceByLocale } from 'utils/utils';

import { 
	OrderDetailBottom, 
	OrderDetailTop, 
	OrderUniqueInfo, 
	OrderDetailTitle, 
	OrderInfoTable, 
	OrderInfoTableRow,
	BottomButton
} from 'components/presenters/commerce/order/OrderDetail';
import OrderItem from 'components/presenters/commerce/order/OrderItem';
import SplitterBar from 'components/presenters/common/SplitterBar';

export default function OrderDetail({ orderNo }) {
	const [orderData, setOrderData] = useState(null);

	const loadOrderData = useCallback(async () => {
		try {
			const form = {};
			form.is_show_shipping_data = true;
			form.is_show_payment_data = true;
			form.show_order_items = true;

			const queryString = qs.stringify(form);
			const response = await server.getRequestData(`commerce/orders/${orderNo}?${queryString}`);
			if(response.success !== 1) {
				const errData = response.error.res_data;
				throw errData;
			}
			const { order } = response.data; 
			setOrderData(order);

		} catch(error) {
			console.log(error);
		}
	})

  useEffect(() => {
    if(orderNo)
    {
      loadOrderData();  
    } else {
      setOrderData(null);
    }

  }, [orderNo])

  return (
    <>
      <OrderDetailTop>
        <OrderUniqueInfo orderNo={orderNo} orderDate={orderData?.create_date}/>
        {orderData?.order_items.map((item) => (
          <OrderItem 
            key={`order_item_no_${item.no}`}
            isChallenge={item.is_challenge} 
            bannerImg={item.product.banner_img}
            title={item.product.title}
            optionName={item.variant_options[0].name} 
            unitPrice={item.unit_price}
            quantity={item.quantity}
            challengeUnitPrice={item.challenge_unit_price}
          />
        ))}
      </OrderDetailTop>
      {/* <SplitterBar color={'#F7F7F7'} height={'calc(100vw * (12 / 375))'}/> */}
      <OrderDetailBottom>
        <OrderDetailTitle />
        <OrderInfoTable title={'배송지 정보'} marginBottom={'calc(100vw * (52 / 375))'}>
          <SplitterBar margin={'0 0 calc(100vw * (20 / 375)) 0'} color={'#E5E5E5'}/>
          <OrderInfoTableRow name={'받는 사람'} value={orderData?.recipient}/>
          <OrderInfoTableRow name={'연락처'} value={formatPhoneNumber(orderData?.phone)}/>
          <OrderInfoTableRow name={'주소'} value={`${orderData?.address1}\n${orderData?.address2}`}/>
          <OrderInfoTableRow name={'배송메모'} value={orderData?.shipping_action}/>
        </OrderInfoTable>
        <OrderInfoTable title={'결제 정보'} marginBottom={'calc(100vw * (36 / 375))'}>
          <SplitterBar margin={'0 0 calc(100vw * (20 / 375)) 0'} color={'#E5E5E5'}/>
          <OrderInfoTableRow name={'상품 금액'} value={`${formatPriceByLocale('ko', orderData?.subtotal)}원`}/>
          <OrderInfoTableRow name={'배송비'} value={`(+) ${formatPriceByLocale('ko', orderData?.total_shipping)}원`}/>
          <OrderInfoTableRow name={'결제금액'} value={`${formatPriceByLocale('ko', orderData?.total_price)}원`}/>
          <OrderInfoTableRow name={'결제방법'} value={'카드'}/>
          <OrderInfoTableRow name={'주문자'} value={orderData?.recipient}/>
          <OrderInfoTableRow name={'연락처'} value={formatPhoneNumber(orderData?.phone)}/>
        </OrderInfoTable>
        <BottomButton />
      </OrderDetailBottom>
    </>
  )
}